<div class="px-5">
    <h1>Consultas</h1>
    <app-admin-table [mapHeader]="mapHeader" [queryset]="data$" [exportFile]="'Contactos'"></app-admin-table>
</div>